// Components
import Chip from "./Chip";

const ChipContainer = (props) => {
    return <Chip {...props} />;
};

export default ChipContainer;
